import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/auth";
import { ShieldCheck, ShieldAlert, RefreshCw } from "lucide-react";

export function AuditLog() {
  const [rows, setRows] = useState([]);
  const [check, setCheck] = useState(null);

  const load = async () => {
    const [a, v] = await Promise.all([axios.get(`${API}/admin/audit`), axios.get(`${API}/admin/audit/verify`)]);
    setRows(a.data); setCheck(v.data);
  };
  useEffect(() => { load().catch(() => {}); }, []);

  return (
    <div className="card-lhs p-5 space-y-4" data-testid="audit-log">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className="font-display font-bold uppercase tracking-wider text-sm">Journal d'audit signé</h2>
        <div className="flex items-center gap-3">
          {check && (
            <span data-testid="audit-integrity" className={`text-xs font-mono-tech flex items-center gap-1 ${check.ok ? "text-emerald-400" : "text-red-400"}`}>
              {check.ok ? <ShieldCheck className="w-4 h-4" /> : <ShieldAlert className="w-4 h-4" />}
              {check.ok ? `Chaîne intègre · ${check.total} entrées` : `${check.broken.length} entrée(s) altérée(s)`}
            </span>
          )}
          <button onClick={load} data-testid="audit-refresh" className="text-zinc-400 hover:text-orange-400"><RefreshCw className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="space-y-2 max-h-[60vh] overflow-y-auto scroll-thin">
        {rows.length === 0 && <div className="text-sm text-zinc-500 italic">Aucune action enregistrée.</div>}
        {rows.map(e => (
          <div key={e.id} className="rounded-lg border border-zinc-800 bg-[#0C0C10] p-3 text-xs" data-testid={`audit-row-${e.id}`}>
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <span className="font-mono-tech text-orange-400">{e.action}</span>
              <span className={`font-mono-tech ${e.result === "ok" ? "text-emerald-400" : "text-red-400"}`}>{e.result}</span>
            </div>
            <div className="text-zinc-400 mt-1">{e.admin_name} · {e.admin_email} · {new Date(e.at).toLocaleString("fr-FR")} · IP {e.ip || "—"}</div>
            <div className="text-[10px] text-zinc-600 font-mono-tech mt-1 truncate">sig {e.sig}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
